import { getIntrinsicElementProps, slot } from '@fluentui/react-components';
import { usePreviewContext_unstable } from '@fluentui-copilot/react-preview';
import type { CitationProps, CitationState } from './Citation.types';
import { useDesignVersion } from '@fluentui-copilot/react-provider';
/**
 * Create the state required to render Citation.
 *
 * The returned state can be modified with hooks such as useCitationStyles_unstable,
 * before being passed to renderCitation_unstable.
 *
 * @param props - props from this instance of Citation
 * @param ref - reference to root HTMLElement of Citation
 */
export const useCitation_unstable = (props: CitationProps, ref: React.Ref<HTMLAnchorElement>): CitationState => {
  const { referenceHref, block = false, ...otherProps } = props;
  const designVersion = useDesignVersion(props.designVersion);

  const isPopoverLocked = usePreviewContext_unstable(ctx => ctx.isPreviewLocked) && (props['aria-expanded'] as boolean);

  const state: CitationState = {
    block,
    designVersion,
    isPopoverLocked,
    components: {
      root: 'a',
    },
    root: slot.always(
      getIntrinsicElementProps('a', {
        ref,
        href: referenceHref,
        role: undefined,
        'aria-expanded': undefined,
        ...otherProps,
      }),
      { elementType: 'a' },
    ),
  };

  return state;
};
